import { Link } from 'react-router-dom';

export default function Dashboard() {
  const cards = [
    { to: '/admin/backgrounds', title: 'Backgrounds', desc: 'Swap hero images per page' },
    { to: '/admin/events', title: 'Events', desc: 'Create and manage events' },
    { to: '/admin/news', title: 'News', desc: 'Publish news articles' },
    { to: '/admin/members', title: 'Members', desc: 'Manage homepage member cards' },
  ];

  return (
    <div>
      <h1 className="text-2xl font-bold text-brand-dark mb-2">Dashboard</h1>
      <p className="text-gray-500 mb-8">Manage all website content from here.</p>
      <div className="grid sm:grid-cols-3 gap-4">
        {cards.map((card) => (
          <Link
            key={card.to}
            to={card.to}
            className="block p-6 bg-white rounded-xl border border-gray-200 hover:border-brand-purple hover:shadow-md transition-all"
          >
            <h2 className="font-semibold text-brand-dark mb-1">{card.title}</h2>
            <p className="text-sm text-gray-500">{card.desc}</p>
          </Link>
        ))}
      </div>
    </div>
  );
}
